module.exports = __webpack_public_path__ + "static/media/54.ff7647a.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/54.wav
// module id = OrG3
// module chunks = 0